var __rspack_ns_object = JSON.parse('{"title":"Test Scripts","placeholder":"Test script management features coming soon"}')